import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { saveAbout, updateAbout } from './actions';
import Editor from '../../components/common/Editor';
import TextField from '../../components/common/TextField';
import DropNCropField from '../../components/common/DropNCropField';
import { ABOUT_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class AboutForm extends Component {
  onSubmit = formProps => {
    const { lang } = formProps;
    const { id } = this.props.initialValues;

    const aboutRequestData = {
      title: formProps.title,
      subtitle: formProps.subtitle,
      content: formProps.content,
      description: formProps.description,
      header: formProps.header,
      headerImageLarge: formProps.headerImageLarge.result,
      slug: formProps.slug
    };

    this.props.updateAbout(aboutRequestData, id, lang, () => {
      this.props.history.push('/oklinice');
    });
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="new-about">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            component={TextField}
            type="text"
            label="Hlavní nadpis"
            name="header"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Podnadpis"
            name="subtitle"
            validate={required}
          />
          <Field
            component={DropNCropField}
            label="Hlavní obrázek"
            name="headerImageLarge"
            validate={required}
            minCropBoxWidth={588}
            aspectRatio={16 / 9}
          />
          <div className="editor">
            {/*<Editor placeholder={'Write something...'} />*/}
            <Field
              name="content"
              component={Editor}
              label="Obsah"
              validate={required}
            />
          </div>
          <Field
            component={TextField}
            type="text"
            label="Title"
            name="title"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Url"
            name="slug"
            placeholder="novy-clanek"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Meta description"
            name="description"
            validate={required}
          />
          <div className="form-buttons">
            <Button color="primary">Uložit</Button>
            <Button tag={Link} to="/oklinice" color="danger">
              Zpět
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  saveAbout,
  updateAbout
};

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  ),
  reduxForm({ form: ABOUT_FORM_NAME })
)(AboutForm);



// WEBPACK FOOTER //
// ./src/modules/AboutForm/index.js